import { formatRupiah } from "@navibiz/chat-core";

export { formatRupiah };

const integer = new Intl.NumberFormat("id-ID");
const compact = new Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 });
const percent = new Intl.NumberFormat("id-ID", { style: "percent", maximumFractionDigits: 0 });

export const fmt = {
  int: (value: number) => integer.format(Math.round(value)),
  /** 12,9 rb · 1,3 jt — for stat tiles and axis ticks. */
  compact: (value: number) => compact.format(value),
  percent: (ratio: number) => percent.format(ratio),
  rupiah: (milli: number) => formatRupiah(milli),
  /** Rupiah with compact notation for big balances in tight spots: Rp 2,2 jt. */
  rupiahCompact: (milli: number) => `Rp ${compact.format(milli / 1000)}`,
  tokens: (value: number) => (value >= 10_000 ? compact.format(value) : integer.format(value)),
};

const dateTime = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const dateOnly = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short", year: "numeric" });
const dayMonth = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short" });
const weekday = new Intl.DateTimeFormat("id-ID", { weekday: "short", day: "numeric", month: "short" });
const relative = new Intl.RelativeTimeFormat("id-ID", { numeric: "auto" });

export const when = {
  dateTime: (iso: string) => dateTime.format(new Date(iso)),
  date: (iso: string) => dateOnly.format(new Date(iso)),
  /** 'YYYY-MM-DD' day keys → "12 Sep" (parsed as a calendar day, not a UTC instant). */
  day: (key: string) => dayMonth.format(new Date(`${key}T12:00:00`)),
  dayLong: (key: string) => weekday.format(new Date(`${key}T12:00:00`)),
  ago: (iso: string | null) => {
    if (!iso) return "—";
    const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
    const units: [Intl.RelativeTimeFormatUnit, number][] = [
      ["year", 31_536_000],
      ["month", 2_592_000],
      ["week", 604_800],
      ["day", 86_400],
      ["hour", 3_600],
      ["minute", 60],
    ];
    for (const [unit, size] of units) if (Math.abs(seconds) >= size) return relative.format(Math.round(seconds / size), unit);
    return "baru saja";
  },
};

/** Catalog v4 (sheet AI Chatbot): who installs x Linkage. */
export const PRODUCT_LABEL: Record<string, string> = {
  "ai-a": "AI-A Asisten AI Add-on",
  "ai-al": "AI-AL Add-on + Linkage",
  "ai-p": "AI-P Chatbot Dipandu",
  "ai-pl": "AI-PL Dipandu + Linkage",
  "ai-k": "AI-K Chatbot Dikerjakan",
  "ai-kl": "AI-KL Dikerjakan + Linkage",
};
/** Short code for badges: "AI-AL". */
export const productCode = (product: string) => product.toUpperCase();
export const isAddon = (product: string) => product === "ai-a" || product === "ai-al";
export const hasLinkage = (product: string) => product.endsWith("l");

export const ROLE_LABEL: Record<string, string> = { admin: "Admin", specialist: "AI Specialist", finance: "Keuangan", client: "Klien" };
